// extracted by mini-css-extract-plugin
export default {"side-tag":"style_side-tag__eVfPw","wrapper":"style_wrapper__ktTMT","tag":"style_tag__e53rH","close":"style_close__VmJ8B","link-text":"style_link-text__L0lHB"};